import PropTypes from 'prop-types';
import './styles/heroStyles.css';

const HeroTemplate = ({ children }) => {
  return (
    <div className="hero-template bg-gray-1 mb-8 p-16">
      <div className="max-w-3xl mx-auto">{children}</div>
    </div>
  );
};

HeroTemplate.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HeroTemplate;
